"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CANVAS_BUTTON_TYPE = void 0;
var CANVAS_BUTTON_TYPE = 'canvasbutton';
exports.CANVAS_BUTTON_TYPE = CANVAS_BUTTON_TYPE;